import { useEffect, useState } from 'react';

/**
 * Tracks whether the browser believes it has a connection.
 *
 * `navigator.onLine` is a hint, not a guarantee — it reports the network interface, not whether
 * Laseera is reachable — so it is used to explain a failure, never to pre-emptively block a
 * request. The API client's own {@code NetworkError} is the authority.
 */
export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState(() => globalThis.navigator?.onLine ?? true);

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    globalThis.addEventListener('online', goOnline);
    globalThis.addEventListener('offline', goOffline);
    return () => {
      globalThis.removeEventListener('online', goOnline);
      globalThis.removeEventListener('offline', goOffline);
    };
  }, []);

  return online;
}
